import React from 'react';

import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import { useState } from 'react';
import { useEffect } from 'react';

const OPTION_INSTRUMENTS = ['option', 'future_option'];

//var prevSymbol = "";
export const validate = (string) => {
  const regex = /^[^\r\n]+$/;
  return regex.test(string);
};

const Symbol = ({
  top,
  dispatchTop,
  componentSymbol,
  setOptionChoices,
  setOptionChains,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
}) => {
  const [textSymbol, setTextSymbol] = useState(''); //need this here so that the this component rerenders when typed into
  const [prevSymbol, setPrevSymbol] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const nextSymbol = top.symbol === undefined ? '' : top.symbol;
    setPrevSymbol(nextSymbol);
    setTextSymbol(nextSymbol);
    componentSymbol.current = nextSymbol;
    if (!validate(top.symbol)) {
      setError('Invalid entry.');
    } else {
      setError('');
    }
  }, [top.symbol]);

  return (
    <div className="m-2">
      <TextField
        id="outlined-basic"
        autoComplete="off"
        size={'small'}
        label={<Typography style={{ fontSize: 10 }}> Symbol </Typography>}
        value={textSymbol}
        onChange={(ev) => {
          setError('');
          const nextSymbol = ev.target.value;
          setTextSymbol(nextSymbol);
          componentSymbol.current = nextSymbol;
        }}
        onBlur={(ev) => {
          const valid = validate(ev.target.value);
          if (!valid) {
            setError('Invalid entry.');
          } //else {
          const newSymbol = ev.target.value;
          const updates = { symbol: newSymbol };
          if (top.instrument === 'option' && newSymbol.startsWith('/')) {
            updates.instrument = 'future_option';
          } else if (top.instrument === 'future_option' && !newSymbol.startsWith('/')) {
            updates.instrument = 'option';
          }
          dispatchTop(updates);
          if (prevSymbol.toUpperCase() !== newSymbol.toUpperCase()) {
            setOptionChoices({});
            setOptionChains({});
            setPrevSymbol(newSymbol);
            if (OPTION_INSTRUMENTS.includes(top.instrument)) {
              if (
                finishedRenderingOptionChain &&
                setFinishedRenderingOptionChain
              ) {
                setFinishedRenderingOptionChain(false);
              }
            }
          }
          //  }
        }}
        //required
      />
      <p
        style={{
          color: 'red',
          fontSize: '10px',
          textAlign: 'center',
          height: '15px',
          margin: '0',
        }}
      >
        {error}
      </p>
    </div>
  );
};

export default Symbol;
